import styled from '@emotion/styled'
import { css } from '@emotion/react'

import { colors, focusOutline } from '../../styles/theme'

const S = {}

const disabledState = css`
  cursor: default;
  color: ${colors.silverChalice};

  .checkmark {
    border-color: ${colors.silverChalice};
  }
`

const activeState = ({ accentColor }) => css`
  color: ${colors.white};

  .checkmark {
    border-color: ${colors.white};
  }

  input:checked ~ .checkmark {
    border: 0.125rem solid ${accentColor ? accentColor : colors.scooter};
  }
`

S.Checkbox = styled.label`
  position: relative;
  color: ${colors.silverChalice};
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  transition: color 0.15s cubic-bezier(0.5, 0, 0.25, 1);
  padding: 0.125rem;
  margin: 0.125rem;
  opacity: ${({ isDisabled }) => isDisabled && 0.5};
  ${focusOutline};

  @media (hover: hover) {
    &:hover {
      ${({ isDisabled }) => (isDisabled ? disabledState : activeState)};
    }
  }

  &:focus, &:focus-within {
    ${({ isDisabled }) => (isDisabled ? disabledState : activeState)};
  }

  .checkbox-wrapper {
    position: relative;
    margin-inline-end: 0.5rem;
  }
`

S.Input = styled.input`
  position: relative;
  opacity: 0;
  z-index: 1;

  &:checked ~ span[type='copy'] {
    color: ${colors.white};
  }

  &:checked ~ .checkmark {
    border: 0.125rem solid
      ${({ accentColor }) => (accentColor ? accentColor : colors.scooter)};
    color: ${({ accentColor }) => (accentColor ? accentColor : colors.scooter)};
  }

  &:checked ~ .checkmark path {
    transition: stroke-dashoffset 0.3s cubic-bezier(0.5, 0, 0.25, 1);
    stroke-dashoffset: 0;
  }

  &:disabled ~ .checkmark {
    border-color: ${colors.silverChalice};
    color: ${colors.silverChalice};
  }

  &:disabled ~ span[type='copy'] {
    color: ${colors.silverChalice};
  }
`

S.Checkmark = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  margin-inline: auto;
  display: block;
  background-color: ${colors.crBlueDark};
  width: 1.25rem;
  height: 1.25rem;
  border: 0.125rem solid ${colors.silverChalice};
  transition: border-color 0.15s cubic-bezier(0.5, 0, 0.25, 1);
  box-sizing: border-box;
  flex-shrink: 0;

  path {
    stroke-linecap: round;
    stroke-dasharray: 180;
    stroke-dashoffset: 180;
  }
`

export default S
